import useOmsenApiClient from "./clients/useOmsenApiClient";
import { useQuery } from "@tanstack/react-query";

export default function useOmsenOccupations(tariffYear?: number) {
  const client = useOmsenApiClient();

  const getOmsenOccupations = async () => {
    const response = await client.apiOmsenOccupationsGet(tariffYear);
    return response.data;
  };

  return useQuery(["omsenOccupations", tariffYear], getOmsenOccupations, {
    refetchOnWindowFocus: false,
    refetchOnMount: false
  });
}
